import React, { useEffect, useState } from "react";
import { Box, Card, CardContent, CardHeader, Paper, Divider, Grid } from "@material-ui/core";
import { useNotify } from "react-admin";

import { PolicyDescription } from "../policy/PolicyDescription";
import { ClaimDbDescription } from "./ClaimDbDescription";
import { ClaimShowMap } from "./ClaimShowMap";
import EnvironmentCondition from "./EnvironmentCondition";

import DopplerVmiDbzMap from "./DopplerVmiDbzMap";
import DopplerDbzMap from "./DopplerDbzMap";
import { PolicyClaimsList } from "../policy/PolicyClaimsList";

import { useTranslation } from "react-i18next";
import httpClient from "../../lib/httpClient";

import { getLatestUpdateDaily } from "../util/tableUtils";
import { computeDopplerFrequencyAndData } from "../util/computeDopplerFrequencyAndData";
import { getUserPermissionsList } from "../util/permissionsUtils";
import { saveUserMonitorData } from "../util/userUtils";
import WarningIcon from "@material-ui/icons/Warning";
import { Typography } from "@material-ui/core";

import i18n from "i18next";
import { PermissionIdEnum } from "../util/types/permissions/permissionIdEnum";

export const ClaimDbShow = (props) => {
  console.log("ClaimDbShow props", props);
  const notify = useNotify();
  const claimId = props.match.params.id.toString();
  const claimRequestArgs = props.location.search;

  const { t } = useTranslation();

  const [policy, setPolicy] = useState({});
  const [policyClaims, setPolicyClaims] = useState([]);
  const [claim, setClaim] = useState({});
  const [longitude, setLongitude] = useState(null);
  const [latitude, setLatitude] = useState(null);
  const [productCommercial, setProductCommercial] = useState(null);
  const [productSireGroup, setProductSireGroup] = useState(null);

  const [showDbzMap, setShowDbzMap] = useState(false);
  const [showVmiDbzMap, setShowVmiDbzMap] = useState(false);
  const [dateOfEvent, setDateOfEvent] = useState(null);
  const [dopplerData, setDopplerData] = useState(null);
  const [dopplerRequestDetails, setDopplerRequestDetails] = useState(null);

  const [lastUpdateDate, setLastUpdateDate] = useState("");
  const [aiVersion, setAiVersion] = useState(0);
  const [errorMsg, setErrorMsg] = useState();

  const updateShowDbz = (checked) => setShowDbzMap(checked);
  const updateShowVmiDbz = (checked) => setShowVmiDbzMap(checked);

  useEffect(() => {
    // See REALERISK-610 to understand why db_claims_daily here.
    getLatestUpdateDaily("/serviceLogs/buildings?service=db_claims_daily").then((lastUpdateMsg) => {
      setLastUpdateDate(lastUpdateMsg);
    });

    const permissions = getUserPermissionsList();
    if (
      permissions.includes(PermissionIdEnum.Super) ||
      permissions.includes(PermissionIdEnum.CysFeatExtendedClaimsVal)
    ) {
      setAiVersion(3);
    }
  }, []);

  useEffect(() => {
    if (claimId) {
      saveUserMonitorData("claimShow", claimId);

      httpClient()
        .get(`/claimsdb/${claimId}${claimRequestArgs}`)
        .then((res) => res.data)
        .then(async (data) => {
          console.log("data", data);

          setClaim(data);
          const { policy } = data;

          setPolicy(policy);

          const foundLatitude = policy?.location?.coordinates[1];
          const foundLongitude = policy?.location?.coordinates[0];
          const foundProductCommercial = policy?.productCommercial;
          const foundProductSireGroup = policy?.productSireGroup;
          const foundDateOfEvent = data.claimEventDate;

          //console.log("foundLatitude", foundLatitude, "foundDateOfEvent", foundDateOfEvent);
          if (foundLatitude && foundLongitude && foundDateOfEvent) {
            setDopplerRequestDetails(
              await computeDopplerFrequencyAndData(foundLatitude, foundLongitude, foundDateOfEvent),
            );
          }
          setLatitude(foundLatitude);
          setLongitude(foundLongitude);
          setProductCommercial(foundProductCommercial);
          setProductSireGroup(foundProductSireGroup);
          setDateOfEvent(foundDateOfEvent);
          setPolicyClaims(data.claims);
        })
        .catch((err) => {
          if (err.response.status === 404) {
            notify("Claim not found", "warning");
            setErrorMsg(`Claim with id ${claimId} was not found`);
          }
        });
    }
  }, [claimId, claimRequestArgs, notify]);

  useEffect(() => {
    const loadDopplerData = async () => {
      const { latitude, longitude, dateAsYYYYMMDD, foundDopplerFrequency } = dopplerRequestDetails;
      setDopplerData({ max_vmi: "Computing..." });
      await httpClient()
        .post("/proxy/doppler", {
          lat: latitude,
          lng: longitude,
          frequency: foundDopplerFrequency,
          date: dateAsYYYYMMDD,
        })
        .then((resp) => resp.data)
        .then((data) => {
          setDopplerData(data);
        })
        .catch((err) => {
          console.log(err.message + " because no doppler data available for " + dateOfEvent);
        });
    };

    if (dopplerRequestDetails) {
      if (dopplerRequestDetails.foundDopplerFrequency > 0) {
        loadDopplerData();
      } else {
        console.log("computeDopplerFrequencyAndData:no doppler data available for " + dateOfEvent);
      }
    }
  }, [dopplerRequestDetails, dateOfEvent]);

  if (errorMsg)
    return (
      <Box mt={2}>
        <h3>{errorMsg}</h3>
      </Box>
    );

  console.log("claim=", claim);
  console.log("Object.keys(claim)=", Object.keys(claim));
  //console.log("Object.keys(policy)=", Object.keys(policy));

  return (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={4}>
        {!Object.keys(claim).length && !errorMsg && <h3>loading...</h3>}
        {Object.keys(claim).length > 0 && (
          <Card style={{ height: "53vw", marginLeft: 5 }}>
            <Paper style={{ height: "53vw", overflow: "auto" }}>
              <CardHeader title={t("claims.description")} />
              <CardContent style={{ paddingTop: "0" }}>
                {policy ? (
                  <PolicyDescription policy={policy} />
                ) : (
                  <>
                    <h4>
                      Policy {claim.policyNumberSecondary} ( {claim.policyNumber}) is missing. If policy is
                      missing, geolocation is not possible. The database does not contain policies that were
                      terminated before 2024-12-31. Also, some recently added policies might be missing.
                    </h4>
                  </>
                )}

                {claim?.claimLocationMessage[i18n.language] && (
                  <Box mt={2} display="flex" alignItems="center">
                    <WarningIcon style={{ color: "orange", marginRight: 8 }} />
                    <Typography variant="body2">{claim.claimLocationMessage[i18n.language]}</Typography>
                  </Box>
                )}

                <Divider />
                <ClaimDbDescription claim={claim} />
              </CardContent>
            </Paper>
          </Card>
        )}
      </Grid>

      <Grid item xs={12} sm={8}>
        <Box p={1}>
          <Card style={{ height: "50vw", marginBottom: 1 }}>
            {showVmiDbzMap && dateOfEvent && latitude && longitude && (
              <DopplerVmiDbzMap
                dateOfEvent={dateOfEvent}
                latitude={latitude}
                longitude={longitude}
                dopplerFrequency={dopplerRequestDetails?.foundDopplerFrequency} // 0,12,48
              />
            )}
            {showDbzMap && dateOfEvent && latitude && longitude && (
              <DopplerDbzMap
                dateOfEvent={dateOfEvent}
                latitude={latitude}
                longitude={longitude}
                dopplerFrequency={dopplerRequestDetails?.foundDopplerFrequency} // 0,12,48
              />
            )}
            {!showVmiDbzMap && !showDbzMap && latitude && longitude && (
              <ClaimShowMap latitude={latitude} longitude={longitude} />
            )}
          </Card>
        </Box>
      </Grid>

      <Grid item xs={12} sm={12}>
        {claim && dateOfEvent && latitude && longitude && (
          <EnvironmentCondition
            latitude={latitude}
            longitude={longitude}
            eventDate={dateOfEvent}
            claim={claim}
            aiVersion={aiVersion}
            productCommercial={productCommercial}
            productSireGroup={productSireGroup}
            updateShowDbz={updateShowDbz}
            updateShowVmiDbz={updateShowVmiDbz}
            dopplerData={dopplerData}
            dopplerFrequency={dopplerRequestDetails?.foundDopplerFrequency} // 0,12,48
          />
        )}
      </Grid>

      <Grid item xs={12} sm={12}>
        {policyClaims > 0 && (
          <PolicyClaimsList claims={policyClaims} lastUpdate={lastUpdateDate}></PolicyClaimsList>
        )}
      </Grid>
    </Grid>
  );
};
